import Cookies from "universal-cookie";

export default function getCookies(ctx, options) {
  // Note: Next.js Static export sets ctx.req to a fake request with no headers
  const header = ctx.req && ctx.req.headers && ctx.req.headers.cookie;
  const  uc = new Cookies(header);

  return uc.getAll(options);
}
